import { useContext } from "react";
import { ThemeContext } from "styled-components";

export function useIsMobile(): boolean {
  // @ts-ignore
  const { isMobile = false } = useContext(ThemeContext);

  return isMobile;
}
